import { React,  useRef, useState, useContext } from "react";
import { Link, NavLink} from "react-router-dom";
import '../Home/Home.css';
import { useTranslation } from "../../utils/hooks/translateHook.js";
import { useLevelContentData } from "../../utils/hooks/translateLevelContentDataHook.js";
import {useCurrentCourseSlug} from "../../utils/getCurrentCourseSlug";
import { CurrentUserContext } from "../../context/CurrentUserContext";

import Arrow from "../../images/icons/StartArrowIcon.svg";
import YELLOEGUYS from "../../images/Yellow Guys.png";
import GirlV from "../../images/Girl Violet.jpg";
import HTML from "../../images/courses/arrow.png";
import PYTHON from "../../images/courses/Rocket.png";
import JAVASCRIPT from "../../images/courses/Pink Computer.png";
import SEO from "../../images/courses/Violet computer.png";
import SMM from "../../images/courses/media.png";
import FUNDAMENTALS from "../../images/courses/Trading.png";


const Home = ({ user, onDesktopClick }) => {
  const t = useTranslation();
  const courseSlug = useCurrentCourseSlug();
  const { currentUser } = useContext(CurrentUserContext);
  const isLoggedIn = !!currentUser;
  
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scroll = (direction) => {
    const container = sliderRef.current;
    const scrollAmount = 240;
    if (direction === "left") {
      container.scrollLeft -= scrollAmount;
      setActiveIndex((prev) => Math.max(prev - 1, 0));
    } else {
      container.scrollLeft += scrollAmount;
      setActiveIndex((prev) => Math.min(prev + 1, 5));
    }
  };

  const coursePath = (path) => {
    if (!courseSlug) return "/courses";
    return `/course/${courseSlug}${path}`
  }

  const translatedLevelContent = useLevelContentData();
  const isGuest = !user ||  !localStorage.getItem("token");
  const userLevel = isGuest ? 0 : user.subscriptionLevel;

  const userLevelContent = translatedLevelContent
    .slice()
    .sort((a, b) => b.level - a.level)
    .find((item) => userLevel>= item.level);

    console.log("🏠 Home loaded for user level:", user.subscriptionLevel);
    const lang = localStorage.getItem("language") || "en";


  return (
    <div className="home-section" key={lang}>
      <div className="home-section__layer">
        <section className="home-section__content" >
         <div className="hero-wrapper">
          <div className="hero">
            <div className="hero-left">
              <h1 className="hero-title-home">
                {t("title1")} <br /> <span>{t("title2")}</span>
              </h1>
              <button className="hero-btn">
                 {t("cta")} 
                 <img className="arrow_c" src={Arrow} alt="" ></img>
              </button>
              <p className="hero-desc">
                {t("desc")}
              </p>
              <ul className="hero-list">
                <li>{t("l1")}</li>
                <li>{t("l2")}</li>
                <li>{t("l3")}</li>
              </ul>
            </div>
            <div className="hero-right">
              <img src={YELLOEGUYS} alt="Hero" />
            </div>
          
          </div>
          
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">40%</span>
              <span className="stat-text">{t("stat1")}</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">85%</span>
              <span className="stat-text">{t("stat2")}</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">30%</span>
              <span className="stat-text">{t("stat3")}</span>
            </div>
          </div>
          
          </div>
        </section>
      
        <div className="home-section__layer">
          <section className="courses-slider">
            <div className="courses-slider__left">
              <h2> Develop core <br /> professional <br /> and personal skills. </h2>
              <p> {t("desc")} </p>
            </div>
            <div className="courses-slider__right">
              <div className="slider-track" ref={sliderRef}>
                {[
                  { img: SMM, title: t("courseHeader_5") },
                  { img: PYTHON, title: t("courseHeader_2") },
                  { img: HTML, title: t("courseHeader_1") },
                  { img: JAVASCRIPT, title: t("courseHeader_3") },
                  { img: SEO, title: t("courseHeader_4") },
                  { img: FUNDAMENTALS, title: t("courseHeader_6") },
                ].map((course, index) => (
                  <Link to="/courses" key={index} className="course-card">
                    <img src={course.img} alt={course.title} />
                    <div className="course-label">{course.title}</div>
                  </Link>
                ))}
              </div>
              <div className="slider-controls">
                <button onClick={() => scroll("left")} className="arrow"> ‹ </button>
                <div className="dots">
                  {[0,1,2,3,4,5].map((i) => (
                    <span key={i} className={i === activeIndex ? "dot active" : "dot"} />
                  ))}
                </div>
                <button onClick={() => scroll("right")} className="arrow"> › </button>
              </div>
            </div>
          </section>
        </div>
      </div>

      {!isLoggedIn && (
        <div className="mobile-auth-buttons">
          <NavLink to="/upgrade"><button className="mobile-signup-btn"> (t{"signIn"}) </button></NavLink>
          <button className="mobile-login-btn" onClick={onDesktopClick}> (t{"login"}) </button>
        </div>
      )}

      <div className="hero-last">
        <img src={GirlV} alt="Girl" className="pic-girl"/>
        <div className="home-flier">
          <h2>{t("title_d")}</h2>
          <div className="hero-text-right">
            <p>{t("p1_d")}</p>
            <p>{t("p2_d")}</p>
            <p>{t("p3_d")}</p>
          </div>
        </div>
      </div>

    </div>

    
  );
};

export default Home;


/*home.js a gorselli welcome yazisini alacagiz */
/* 
App.js = the skeleton that wraps everything and connects routes
Home.jsx = the content shown at / based on the user
LevelContent.jsx = the full detailed training/resources they’ve unlocked
 */